/* import __COLOCATED_TEMPLATE__ from './change-freelancer-agreement-modal.hbs'; */
import { A } from '@ember/array';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { absoluteStoryhunterUrl } from "sh-www/utils/url";
import LSGModalBase from "../lsg/lsg-modal-dialog-base";
import { closeModal } from 'sh-www/utils/modal-controls';

export default LSGModalBase.extend({
  /**
   * Register services
   */
  applicationCommandService : service('commands/application-commands'),
  applicationStateManager: service('state-managers/application'),
  store: service(),

  /**
   * @inheritDoc
   */
  propertyDefaults: {
    /**
     * @param {Application}
     */
    application: null,

    /**
     * @param {Function}      Called after legal has been successfully updated
     */
    onLegalChanged: () => {}
  },

  /**
   * @inheritDoc
   */
  stateDefaults: {
    /**
     * @type {Boolean}    True while we're updating state of the legal
     */
    isUpdating: false
  },

  /**
   * @inheritDoc
   */
  _onInitializationComplete() {
    let appLegalAgreements = this.get('model.application.legalAgreements');
    // there should only be one legal attached to an application at any given time, so this modal
    // will need to be updated if that assumption ever changes

    if (appLegalAgreements) {
      this.set('_legalSelected', appLegalAgreements.objectAt(0).get('legal'));
    }
  },

  /**
   * All available legals provided by the company.
   *
   * @type {Ember.A<Legal>}
   */
  _availableLegals: computed('model.application.buyer.company.legals', function() {
    return this.get('model.application.buyer.company.legals');
  }),

  /**
   * @type {Legal|null}     The legal selected by the user or null
   */
  _legalSelected: null,

  actions: {
    /**
     * The legal id for the radio when the user clicks.
     *
     * @param {String} legalId
     */
    onLegalRadioClicked: function(legalId) {
      let legalSelected = this.get('store').peekRecord('legal', legalId);
      this.set('_legalSelected', legalSelected);
    },

    /**
     * When the user clicks to update the freelancer agreement.
     */
    onUpdateFreelancerAgreementClicked: function() {
      this.set('state.isUpdating', true);

      let legalSelected = this.get('_legalSelected'),
        appLegalAgreements = this.get('model.application.legalAgreements') ?
          this.get('model.application.legalAgreements') :
          A(),
        firstAppLegal = appLegalAgreements.objectAt(0).get('legal');

      if (firstAppLegal && legalSelected.get('id') === firstAppLegal.get('id')) {
        // user has selected the same one, so just let them know and return.
        this.get('applicationStateManager').addToast('Creator agreement updated');
        closeModal(this);
        return;
      }

      this.get('applicationCommandService').changeApplicationLegal(
        this.get('model.application'),
        this.get('_legalSelected')
      ).then(() => {
        this.get('applicationStateManager').addToast('Creator agreement updated');
        this.get('model.onLegalChanged')();
        closeModal(this);
      }).finally(() => this.set('state.isUpdating', false));
    },

    onPDFClicked(legal) {
      window.open(absoluteStoryhunterUrl(`/legals/${legal.id}/download`));
    },

    closeModal() {
      closeModal(this);
    },
  }
});
